import { FC, Fragment, useState } from 'react';

import AutTable from '../../../blocks/aut-grid-table';
import EditAnomalyItemNew from '../../../forms/custom-fvi/editanomalyItemNew';
import AnomalyItemNew from '../../../forms/custom-fvi/anomalyItemNew';

import { getNewCustomFVITableColumns } from '../../../../utils/data';
import { NewAnomalyItem as Anomaly, DamageClassItem } from '../../../../utils/models';

interface NewPipingAnomalyItemsProps {
	nextAnomalyID: number;
	damageClasses: DamageClassItem[];
	anomalyItems: Anomaly[];
	onDataChange: (items: Anomaly[]) => void;
}

const NewPipingAnomalyItems: FC<NewPipingAnomalyItemsProps> = (props) => {
	const [itemToEdit, setItemToEdit] = useState<Anomaly | null>(null);

	const getNewAnomalyID = () => {
		if (props.anomalyItems.length === 0) return props.nextAnomalyID;

		return props.anomalyItems[props.anomalyItems.length - 1].id + 1;
	};

	const handleAddItem = (item: Anomaly) => {
		const newAnomalyItems = [...props.anomalyItems];
		newAnomalyItems.push({ ...item, id: getNewAnomalyID() });

		props.onDataChange(newAnomalyItems);
	};

	const handleDeleteItem = (item: Anomaly): void => {
		const newAnomalyItems = props.anomalyItems.filter((i) => i.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (item: Anomaly): void => {
		props.onDataChange(props.anomalyItems.map((anomaly) => anomaly.id === item.id ? item : anomaly));
		setItemToEdit(null);
	};

	const handleCancelEdit = (): void => {
		setItemToEdit(null);
	};

	return (
		<Fragment>
			{itemToEdit ? (
				<EditAnomalyItemNew
					anomalyItem={itemToEdit}
					onEdit={handleEditItem}
					onCancelEdit={handleCancelEdit}
				/>
			) : (
				<AnomalyItemNew 
					damageClasses={props.damageClasses} 
					onAdd={handleAddItem} 
				/>
			)}

			<div className="divider my-4"></div>

			<AutTable
				data={props.anomalyItems}
				tableColumns={getNewCustomFVITableColumns()}
				onDeleteItem={handleDeleteItem}
				onEditItem={(item: Anomaly) => setItemToEdit(item)}
			/>
		</Fragment>
	);
};

export default NewPipingAnomalyItems;
